import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 're-user-remove-deactivation-date',
  templateUrl: './user-remove-deactivation-date.component.html',
  styleUrl: './user-remove-deactivation-date.component.scss',
  standalone: false
})
export class UserRemoveDeactivationDateComponent {
  constructor(public modal: NgbActiveModal) { }

  deactivationDate: any;

  close() {
    this.modal.close(null);
  }

  activate() {
    this.modal.close(true);
  }
}
